import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {FlightRequestBody} from "app/types/service-types/FlightTypes";
import {FlightService} from 'app/services';
import {errorMsg} from "app/utils/MessageUtils";
import {setFlightForm} from "./flight-form.slice";

interface GetFlightParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const getFlight = (params: GetFlightParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));

    const flightData = await FlightService.getFlightById(params.id);
    if (flightData) {

      const {
        id,
        departureAirport,
        dateOfDeparture,
        timeOfDeparture,
        arrivalAirport,
        gate,
        airlineCompany,
        aircraftId,
        gepack,
        gepackINF,
        increasePriceOfOnlineBookingFor,
        timeOfArrival,
        maxNumberOfTravelers,
        taxOfFlight,
        sectorPrices,
        maxOnline,
        totalAircraftSeats,
        number,
        currency,
        publicAvailability
      } = flightData;

      const formatSectors = sectorPrices.map((item: any) => ({
        ...item,
        prices: item.price
      }));

      const formattedFlight = {
        id,
        number,
        dateOfDeparture: dateOfDeparture,
        timeOfDeparture,
        timeOfArrival,
        gate,
        totalAircraftSeats,
        maxNumberOfTravelers,
        gepack,
        gepackINF,
        maxOnline,
        taxOfFlight,
        increasePriceOfOnlineBookingFor,
        publicAvailability,
        departureAirportId: departureAirport.id,
        arrivalAirportId: arrivalAirport.id,
        departureAirportCode: departureAirport.code,
        arrivalAirportCode: arrivalAirport.code,
        airlineCompanyId: airlineCompany.id,
        aircraftId: aircraftId || "",
        sectorPrices: formatSectors,
        currencyId: currency.id,
      };

      dispatch(setFlightForm(formattedFlight));
      dispatch(setFlight(formattedFlight));
    }
    if (params.onSuccess) params.onSuccess(flightData);
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
  }
}

interface FlightSlice {
  flight: FlightRequestBody | null;
  loading: boolean;
}

const initialState: FlightSlice = {
  flight: null,
  loading: false
}

const stateSlice = createSlice({
  name: 'flights/flight',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setFlight: (state, action) => {
      state.flight = action.payload
    }
  }
});

export const {setLoading, setFlight} = stateSlice.actions;

export default stateSlice.reducer;